module.exports = __webpack_public_path__ + "static/media/photo-10.da597682.jpg";